import { Divider, Grid, Paper } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Input,
  InputAuto,
  InputDate,
  InputSwitch,
} from "../../controls";
import { Model, UseForm } from "../../hooks";
import { Alert, Form } from "../../layout";
import { AppContext } from "../../App";
import { API, actions, endpoints } from "../../api/api";
import { RmvEmptyProp, ToFormData } from "../../hooks/Method";
import moment from "moment";
import { useTranslation } from "react-i18next";

const AddEditMember = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const { branch, authUser } = useContext(AppContext);
  const navigate = useNavigate();
  const { FreezeMdl } = Model();
  const {
    values,
    setValues,
    errors,
    setErrors,
    handleInpChg,
    handleInpDate,
    handleInpCheck,
  } = UseForm(FreezeMdl);
  const [planDtls, setPlanDtls] = useState();
  const [loading, setLoading] = useState(false);
  const [members, setMembers] = useState([]);
  const [memberInvs, setMemberInvs] = useState([]);
  const [invs, setInvs] = useState([]);
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  useEffect(() => {
    if (id && members.length) {
      var member = members.find((j) => j.id === parseInt(id));
      member && setValues((x) => ({ ...x, memberId: member.id }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, members]);

  useEffect(() => {
    if (branch && branch.id) {
      API(endpoints.Member + actions.GetAllByBranch).getById(
        branch.id,
        (res) =>
          res &&
          res.status === 200 &&
          setMembers([
            ...res.result
              .filter((j) => j.accStatus === 1)
              .map((j) => ({
                ...j,
                label: j.firstName + " " + j.lastName + ` (${j.memberId})`,
              })),
          ])
      );
      API(endpoints.Invoice + actions.GetAllByBranch).getById(
        branch.id,
        (res) =>
          res &&
          res.status === 200 &&
          setInvs([
            ...res.result
              .filter((j) => j.status !== 2)
              .map((j) => ({
                ...j,
                id: j.id,
                label: j.title,
                subtitle: `${t("FreeFreeze")}: ${j.freeFreezeCount}`,
              })),
          ])
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branch]);

  useEffect(() => {
    setMemberInvs([...invs.filter((j) => j.memberId === values.memberId)]);
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.memberId, invs]);

  useEffect(() => {
    if (values.invId) {
      var _inv = memberInvs.find((j) => j.id === values.invId);
      if (_inv) {
        setPlanDtls(_inv);
        _inv.freeFreezeCount > 0 && setValues((x) => ({ ...x, amount: 0 }));
      }
    } else {
      setPlanDtls();
      setValues((x) => ({ ...x, amount: "", invId: "" }));
    }
    return () => {
      setPlanDtls();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.invId]);

  useEffect(() => {
    values.waveAmt && setValues((x) => ({ ...x, amount: 0 }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.waveAmt]);

  const validateForm = () => {
    let temp = {};
    temp.memberId = values.memberId !== "" ? "" : t("ValMember");
    temp.startDate = values.startDate !== "" ? "" : t("ValStartDate");
    temp.endDate = values.endDate !== "" ? "" : t("ValEndDate");
    temp.amount = values.amount !== "" ? "" : t("ValAmount");

    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const handleMember = (e) => {
    values.invId = "";
    handleInpChg(e);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm() && branch.id && authUser.id) {
      setLoading(true);
      const onComplete = (res) => {
        setLoading(false);
        if (res) {
          if (res.status === 201 || res.status === 200) {
            setAlert({
              isOpen: true,
              type: "success",
              title: t("Success"),
              subTitle: `${t("Freezed")} ${id ? t("Update") : t("Added")} ${t(
                "Successfully"
              )}.`,
              onClick: () => navigate("/freeze_members"),
            });
          } else
            setAlert({
              isOpen: true,
              type: "error",
              title: t("Error"),
              subTitle: res.msg,
            });
        }
      };
      if (values.id === 0) {
        values.branchId = branch.id;
        values.orgId = branch.orgId;
        values.addedUserId = authUser.id;
        API(endpoints.Freeze + actions.Post).post(
          ToFormData(RmvEmptyProp(values)),
          onComplete
        );
      } else {
        API(endpoints.Freeze + actions.Put).put(
          ToFormData(RmvEmptyProp(values)),
          onComplete
        );
      }
    }
  };

  return (
    <>
      <Form onSubmit={handleSubmit} noValidate>
        <Paper>
          <div className="mb-10 d-flex j-between a-center pt-15 pl-15 pr-15">
            <div>
              <h1
                variant="h5"
                className="form-title mb-5 fw-4 gray-color tx-upp
                    border-left"
              >
                {t("AddFreeze")}
              </h1>
            </div>

            <div>
              <Button type="submit" loading={loading}>
                {id ? t("SaveChanges") : t("Submit")}
              </Button>
            </div>
          </div>
          <Divider />
          <div className="p-15">
            <Grid container spacing={2.5}>
              <Grid item xs={12} md={6}>
                <InputAuto
                  label={t("Member")}
                  name="memberId"
                  required={true}
                  value={values.memberId}
                  error={errors.memberId}
                  onChange={handleMember}
                  disabled={id ? true : false}
                  options={members}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <InputAuto
                  label={t("SubscriptionPlan")}
                  name="invId"
                  required={true}
                  value={values.invId}
                  error={errors.invId}
                  onChange={handleInpChg}
                  options={memberInvs}
                  disabled={memberInvs.length ? false : true}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <Input
                  label={t("Amount")}
                  name="amount"
                  required={true}
                  type="number"
                  value={values.amount}
                  error={errors.amount}
                  onChange={handleInpChg}
                  disabled={
                    !(planDtls && planDtls.freeFreezeCount > 0) &&
                    values.invId &&
                    !values.waveAmt
                      ? false
                      : true
                  }
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <InputDate
                  label={t("StartDate")}
                  name="startDate"
                  required={true}
                  value={new Date(values.startDate)}
                  error={errors.startDate}
                  minDate={new Date()}
                  maxDate={moment(values.endDate, "MM/DD/YYYY").subtract(
                    1,
                    "days"
                  )}
                  onChange={(date) =>
                    handleInpDate(
                      "startDate",
                      new Date(date).toLocaleDateString()
                    )
                  }
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <InputDate
                  label={t("EndDate")}
                  name="endDate"
                  required={true}
                  value={new Date(values.endDate)}
                  error={errors.endDate}
                  minDate={moment(values.startDate, "MM/DD/YYYY").add(
                    1,
                    "days"
                  )}
                  disabled={values.startDate ? false : true}
                  onChange={(date) =>
                    handleInpDate(
                      "endDate",
                      new Date(date).toLocaleDateString()
                    )
                  }
                />
              </Grid>
              {planDtls && planDtls.freeFreezeCount <= 0 && (
                <Grid item xs={12}>
                  <InputSwitch
                    label={t("WaveAmount")}
                    name="waveAmt"
                    fontSize="16px"
                    checked={JSON.parse(values.waveAmt)}
                    onChange={handleInpCheck}
                  />
                </Grid>
              )}
            </Grid>
          </div>
          {planDtls && (
            <>
              <Divider className="pt-10 mb-10" />
              <div className="p-15 pb-20">
                <div className="mb-20">
                  <span className="fs-16 mb-5 fw-4 gray-color tx-upp border-left">
                    {t("MemberDetails")}
                  </span>
                </div>

                <Grid container spacing={3}>
                  <Grid item xs={12} md={4.5} className="d-grid">
                    <span className="tx-xs tx-upp mb-5 grayMD-color">
                      {t("PlanSubscribed")}
                    </span>
                    <span className="fs-18 fw-4 gray-color">
                      {planDtls.title}
                    </span>
                  </Grid>
                  <Grid item xs={12} md={2.5} className="d-grid">
                    <span className="tx-xs tx-upp mb-5 grayMD-color">
                      {t("PlanStartDate")}
                    </span>
                    <span className="fs-18 fw-4 gray-color">
                      {planDtls.startDate}
                    </span>
                  </Grid>
                  <Grid item xs={12} md={2.5} className="d-grid">
                    <span className="tx-xs tx-upp mb-5 grayMD-color">
                      {t("PlanEndDate")}
                    </span>
                    <span className="fs-18 fw-4 gray-color">
                      {planDtls.endDate}
                    </span>
                  </Grid>
                  <Grid item xs={12} md={2.5} className="d-grid">
                    <span className="tx-xs tx-upp mb-5 grayMD-color">
                      {t("FreeFreezeCount")}
                    </span>
                    <span className="fs-18 fw-4 gray-color">
                      {planDtls.freeFreezeCount}
                    </span>
                  </Grid>
                </Grid>
              </div>
            </>
          )}
        </Paper>
      </Form>
      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

export default AddEditMember;
